import { render, staticRenderFns } from "./node.vue?vue&type=template&id=8068771a&"
import script from "./node.vue?vue&type=script&lang=js&"
export * from "./node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8068771a')) {
      api.createRecord('8068771a', component.options)
    } else {
      api.reload('8068771a', component.options)
    }
    module.hot.accept("./node.vue?vue&type=template&id=8068771a&", function () {
      api.rerender('8068771a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tree/node.vue"
export default component.exports